<template>
  <div class="repost-detail">
    <div class="detail-container" @click.stop="" v-if="model">
      <div
        class="switch-btn left"
        @click="prevClick()"
        :class="{ hide: !hasPrev }"
      ></div>
      <div class="main-container">
        <div class="media-container" :style="style">
          <div class="media-item" v-if="images.length === 1">
            <img v-show="images[0].type === 1" :src="images[0].url" />
            <media-video
              :src="images[0].url"
              v-show="images[0].type === 2"
              :poster="images[0].coverUrl"
            ></media-video>
          </div>
          <el-carousel
            ref="images"
            style="height: 100%"
            arrow="always"
            v-if="images.length > 1"
            :autoplay="false"
            :loop="false"
          >
            <el-carousel-item
              style="height: 100%"
              v-for="img in images"
              :key="img.id"
            >
              <div class="media-item">
                <img v-show="img.type === 1" :src="img.url" />
                <media-video
                  :src="img.url"
                  v-show="img.type === 2"
                  :poster="img.coverUrl"
                ></media-video>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div
          class="info-container"
          :style="{ height: style.height }"
          ref="info"
        >
          <div class="user-info" @click="userInfoClick">
            <div
              class="user-image"
              :key="model.user.social_profile_picture"
              v-lazy:background-image="model.user.social_profile_picture"
            ></div>
            <div class="right-container">
              <div class="username">
                {{ model.user.social_username }}
                <div
                  class="approve-icon"
                  v-show="model.user.social_is_verified"
                ></div>
              </div>
              <div class="des">{{ model.user.social_name }}</div>
            </div>
            <div class="close-btn" @click.stop="closeClick"></div>
          </div>
          <div class="caption-container">{{ model.caption }}</div>
          <div class="time-container">{{ model.postStr }}</div>
          <div class="bottom-container">
            <div
              class="saved-icon"
              :class="{ select: model.saved }"
              @click="saveClick"
            ></div>
            <hi-button class="repost-btn" type="primary" @click="repostClick"
              >Repost</hi-button
            >
          </div>
        </div>
      </div>
      <div
        class="switch-btn right"
        @click="nextClick()"
        :class="{ hide: !hasNext }"
      ></div>
    </div>
  </div>
</template>
<style lang="less">
.repost-detail {
  .el-carousel__container {
    height: 100% !important;
  }
}
</style>
<style lang="less" scoped>
@import "../../assets/style/theme.less";

.repost-detail {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 400;

  .detail-container {
    display: flex;
    align-items: center;

    .main-container {
      display: flex;

      .media-container {
        background: rgb(240, 240, 240);

        .media-item {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          img {
            height: 100%;
            width: 100%;
          }
        }
      }

      .info-container {
        width: 355px;
        background: white;
        display: flex;
        flex-direction: column;
        border-left: 1px solid @border-color;

        .user-info {
          margin: 0 20px;
          border-bottom: 1px solid #e6e6e6;
          height: 80px;
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;

          .user-image {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-size: contain;
          }

          .right-container {
            flex: 1;
            margin-left: 10px;

            .username {
              font-size: 16px;
              display: flex;
              align-items: center;
              font-weight: 500;

              .approve-icon {
                background-image: url("../../../public/images/schedule_posts/tag_people/approve@3x.png");
                width: 12px;
                height: 12px;
                background-size: contain;
                margin-left: 4px;
                position: relative;
              }
            }

            .des {
              font-size: 14px;
              margin-top: 2px;
            }
          }

          .close-btn {
            width: 20px;
            height: 20px;
            position: absolute;
            right: 0;
            top: 20px;
            background-image: url("../../../public/images/common/Close@3x.png");
            background-size: contain;
            cursor: pointer;
          }
        }

        .caption-container {
          flex: 1;
          white-space: pre-wrap;
          word-break: break-all;
          padding: 10px 20px;
          text-align: left;
          overflow: auto;
          font-size: 14px;
        }

        .time-container {
          color: @font-color-gray;
          font-size: 14px;
          padding: 15px 20px;
        }

        .bottom-container {
          height: 64px;
          display: flex;
          align-items: center;
          padding: 0 20px;
          border-top: 1px solid #e6e6e6;
          justify-content: space-between;

          .repost-btn {
            width: 98px;
            height: 30px;
            font-size: 14px;
          }

          .saved-icon {
            width: 24px;
            height: 24px;
            background-size: contain;
            cursor: pointer;
            background-image: url("../../../public/images/repost/Saved@3x.png");

            &.select {
              background-image: url("../../../public/images/repost/Saved_Filled@3x.png");
            }
          }
        }
      }
    }

    .switch-btn {
      width: 40px;
      height: 40px;
      cursor: pointer;
      background-size: contain;

      &:hover,
      &:active {
        opacity: 0.7;
      }

      &.hide {
        background-image: none !important;
      }

      &.left {
        background-image: url("../../../public/images/repost/Left@3x.png");
      }

      &.right {
        background-image: url("../../../public/images/repost/Right @3x.png");
      }
    }
  }
}
</style>

<script>
import { imageLoad } from "../../utils/media";
import hiButton from "../../components/button/Index";
import MediaVideo from "../common/media/Video";
import { showErrorMsg } from "../../utils/errors";
import { mediaSave, delMediaSaved } from "../../service/instagram";
import { mapGetters } from "vuex";
import { CURRENT_PUBLISHER_SIMPLE } from "../../store/mutation-types";

export default {
  name: "RepostDetailComponent",
  components: { MediaVideo, hiButton },
  data() {
    return {
      model: null,
      switchInfo: null, // 前一页后一页所需信息
      style: {
        width: "40vw",
        height: "40vw",
      },
    };
  },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    images() {
      if (this.model.images) {
        return this.model.images;
      } else {
        return [];
      }
    },
    hasPrev() {
      if (this.switchInfo === null) {
        return false;
      }
      return !this.switchInfo.first;
    },
    hasNext() {
      if (this.switchInfo === null) {
        return false;
      }
      return this.switchInfo.next;
    },
  },
  methods: {
    /**
     * 跳转用户详情点击事件
     */
    userInfoClick() {
      this.closeClick();
      this.$bus.$emit("toInsProfile", this.model);
    },
    async saveClick() {
      const loading = this.$loading({
        target: this.$refs.info,
      });
      try {
        if (this.model.saved) {
          await delMediaSaved({
            mediaId: this.model.mediaId,
            model: this.model,
          });
        } else {
          await mediaSave({ mediaId: this.model.mediaId, model: this.model });
        }
        this.model.saved = !this.model.saved;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    repostClick() {
      this.$emit("close");
      const scheduleForm = {
        images: this.model.images,
        user: this.model.user,
        type: "saved",
        form: this.model.form,
        mediaType: this.model.mediaType,
        id: this.model.id,
        tempForm: this.model.tempForm,
        fromType: this.model.fromType,
      };
      this.$bus.$emit("showScheduleForm", scheduleForm);
    },
    async nextClick() {
      const last = this.switchInfo.last;
      if (last) {
        this.$loading();
      }
      if (!this.hasNext) {
        return;
      }
      try {
        this.$bus.$emit("getSavedInfo", {
          mediaId: this.model.mediaId,
          type: "next",
          callback: async ({ switchInfo }) => {
            this.switchInfo = switchInfo;
            this.model = switchInfo.model;
            if (last) {
              this.$loading().close();
            }
            await this.initStyle();
          },
        });
      } catch (e) {
        showErrorMsg(e);
      }
    },
    async prevClick() {
      if (!this.hasPrev) {
        return;
      }
      this.$bus.$emit("getSavedInfo", {
        mediaId: this.model.mediaId,
        type: "prev",
        callback: async ({ switchInfo }) => {
          this.switchInfo = switchInfo;
          this.model = switchInfo.model;
          await this.initStyle();
        },
      });
    },
    /**
     * 初始化样式
     */
    async initStyle() {
      const img = await imageLoad({ src: this.model.images[0].coverUrl });
      const ratio = img.width / img.height;
      const base = 500;
      if (ratio > 1) {
        this.style = {
          width: `${base}px`,
          height: `${base / ratio}px`,
        };
      } else {
        this.style = {
          width: `${base * ratio}px`,
          height: `${base}px`,
        };
      }
      // 重新初始化切换图片到第一个
      const imageContainer = this.$refs.images;
      if (imageContainer) {
        imageContainer.setActiveItem(0);
      }
    },
    /**
     * 展示详情信息
     * @param detail
     */
    async show({ detail }) {
      this.model = detail;
      // 获取图片比例
      await this.initStyle();
      // 同时查看是否可以切换，如果可以切换则获取前一项后一项信息
      if (this.model.canSwitch) {
        this.$bus.$emit("getSavedInfo", {
          mediaId: this.model.mediaId,
          type: "current",
          callback: async ({ switchInfo }) => {
            this.switchInfo = switchInfo;
            this.model = switchInfo.model;
            await this.initStyle();
          },
        });
      } else {
        this.switchInfo = null;
      }
    },
    closeClick() {
      this.$emit("close");
    },
  },
};
</script>
